import React from "react";
import { Box, IconButton } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export interface PreviewImageProps {
    imageSrc: string; // L'image à afficher
    onRetake: () => void; // Action pour reprendre une photo
    onValidate: () => void; // Action pour valider l'image
}

export const PreviewImage: React.FC<PreviewImageProps> = ({ imageSrc, onRetake, onValidate }) => {
    return (
        <Box
            sx={{
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%", // Utilisez 100% pour éviter les débordements
                height: "100%", // Assurez-vous d'occuper toute la hauteur
                backgroundColor: "#000",
                overflow: "hidden", // Empêche les débordements
            }}
        >
            {/* Image en plein écran */}
            <img
                src={imageSrc}
                alt="Preview"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // Adapte l'image pour remplir l'écran
                }}
            />

            {/* Contrôles en bas */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: "5vh",
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    gap: 2,
                    padding: 2,
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // Fond semi-transparent
                    borderRadius: "8px",
                }}
            >
                {/* Bouton pour reprendre une photo */}
                <IconButton
                    onClick={onRetake}
                    sx={{
                        color: "white",
                        "&:hover": { color: "gray" },
                    }}
                >
                    <ReplayIcon sx={{ fontSize: "32px" }} />
                </IconButton>

                {/* Bouton pour valider l'image */}
                <IconButton
                    onClick={onValidate}
                    sx={{
                        color: "white",
                        "&:hover": { color: "gray" },
                    }}
                >
                    <CheckCircleOutlineIcon sx={{ fontSize: "32px" }} />
                </IconButton>
            </Box>
        </Box>
    );
};
